
import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "./CreditDetails.css";
import { Api } from "../Api/Api";

export default function CreditDetails() {
  const [bills, setBills] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingId, setEditingId] = useState(null);
  const [editPaid, setEditPaid] = useState("");

  useEffect(() => {
    fetchBills();
  }, []);

  const fetchBills = async () => {
    try {
      const res = await axios.get(`${Api}bills/get2.php`);
      console.log(res.data);
      if (res.data.ok) {
        setBills(res.data.bills || []);
      }
    } catch (err) {
      console.error("Error fetching bills:", err);
    } finally {
      setLoading(false);
    }
  };

  const handlePaymentCleared = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to clear this payment?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, clear it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.post(`${Api}bills/clear.php`, { id });
          setBills((prev) => prev.filter((bill) => bill.id !== id));
          Swal.fire("Cleared!", "The payment has been cleared.", "success");
        } catch (err) {
          Swal.fire("Error!", "Something went wrong.", "error");
        }
      }
    });
  };

  const handleEdit = (bill) => {
    setEditingId(bill.id);
    setEditPaid(bill.paid_amount);
  };

  const handleSaveEdit = async (id) => {
    try {
      const res = await axios.put(`${Api}bills/update.php`, {
        id,
        paid_amount: editPaid,
      });
      if (res.data.status === "success") {
        setBills((prev) =>
          prev.map((b) =>
            b.id === id
              ? {
                  ...b,
                  paid_amount: res.data.paid_amount,
                  balance_due: res.data.balance_due,
                }
              : b
          )
        );
        setEditingId(null);
        Swal.fire("Updated!", "Payment updated successfully.", "success");
      }
    } catch (err) {
      Swal.fire("Error!", "Update failed.", "error");
    }
  };

  return (
    <div className="credit-container">
      <h2>Credit Bills</h2>

      {loading ? (
        <p>Loading...</p>
      ) : bills.length === 0 ? (
        <p>No credit bills found.</p>
      ) : (
        <table className="main-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Invoice No</th>
              <th>Bill Date</th>
              <th>Company</th>
              <th>Buyer</th>
              <th>Items</th>
              <th>Subtotal</th>
              <th>Grand Total</th>
              <th>Paid</th>
              <th>Balance</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {bills.map((bill, index) => (
              <tr key={bill.id}>
                <td>{index + 1}</td>
                <td>{bill.invoice_no}</td>
                <td>{bill.bill_date}</td>
                <td>{bill.company_name}</td>
                <td>{bill.buyer_name}</td>
                <td>{bill.items.length} items</td>
                <td>₹{bill.subtotal}</td>
                <td>₹{bill.grand_total}</td>
                <td>
                  {editingId === bill.id ? (
                    <input
                      type="number"
                      value={editPaid}
                      onChange={(e) => setEditPaid(e.target.value)}
                    />
                  ) : (
                    `₹${bill.paid_amount}`
                  )}
                </td>
                <td>₹{bill.balance_due}</td>
               

                <td>
                  {editingId === bill.id ? (
                    <div className="btn-group">
                      <button
                        className="btn save-btn"
                        onClick={() => handleSaveEdit(bill.id)}
                      >
                        Save
                      </button>
                      <button
                        className="btn cancel-btn"
                        onClick={() => setEditingId(null)}
                      >
                        Cancel
                      </button>
                    </div>
                  ) : (
                    <div className="btn-group">
                      <button
                        className="btn edit-btn"
                        onClick={() => handleEdit(bill)}
                      >
                        Edit
                      </button>
                      <button
                        className="btn clear-btn"
                        onClick={() => handlePaymentCleared(bill.id)}
                      >
                        Payment Cleared
                      </button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
